export enum RouteAlertStatus {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
